/**
 * 
 * @param {String} idCard 身份证号
 * @param {Number} type 类型
 * @returns 
 */
export function getAgeSexByIdCard(idCard, type) {
  if (type === 1) {
    //获取出生日期
    let birthday = idCard.substring(6, 10) + '-' + idCard.substring(10, 12) + '-' + idCard.substring(12, 14);
    return birthday;
  }
  if (type === 2) {
    //获取性别
    if (parseInt(idCard.substring(16, 1)) % 2 === 1) {
      return '男';
    } else {
      return '女';
    }
  }
  if (type === 3) {
    //获取年龄
    let ageDate = new Date();
    let month = ageDate.getMonth() + 1;
    let day = ageDate.getDate();
    let age = ageDate.getFullYear() - idCard.substring(6, 10) - 1;
    if (
      idCard.substring(10, 12) < month ||
      (idCard.substring(10, 12) === month && idCard.substring(12, 14) <= day)
    ) {
      age++;
    }
    if (age <= 0) {
      age = 1;
    }
    return age;
  }
}

/**
  * @param {Object}  arrObj 对象数组
  * @param {Array}  keyList 去重的参数 ['id','staffName','mobileNo']
*/
export function removeDuplicates(arrObj,keyList) {
  let getKey = (arrObjItem) => {
    let str = '';
    keyList.forEach((keyItem) => {
      str = str + (arrObjItem[keyItem] || '');
    });
    return str;
  };
  const map = new Map();
  const newArr = arrObj.filter((v) => !map.has(getKey(v)) && map.set(getKey(v), v));
  return newArr;
}

/**
 * @param { Array } list 排序数组
 * @param { String } key 排序的字段
 * @param { String } type 升序降序
 * @return { Array } 排序后的数组
 */
export function getSortList(list,key,type) {
  return list.sort((a, b) => {
    var nameA = a[key]
    var nameB = b[key]
    if (nameA < nameB) {
      return type === '升序' ? -1 : 1; 
    }
    if (nameA > nameB) {
      return type === '升序' ? 1 : -1; 
    }
    return 0;
  })
}

/**
 * 监听防抖
 * @param {String} func 回调
 * @param {Number} delay 延迟
 * @returns 
 */
export function debounce(func, delay) {
  let timerId
  return function(...args) {
    clearTimeout(timerId)
    timerId = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

/**
 * 查看报告
 */
export function onPreview(file) {
  const name = file.fileName || file.name
  let fileSuffix = name ? name.substring(name.lastIndexOf('.') + 1) : '';
  if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf' || fileSuffix === 'zip') {
    return window.open(file.path, name);
  }
  window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
}

/**
 * 递归拿item
 * @param key 根据key值，拿到item
 * @param value key 对应的值
 * @param tree 树
 * @returns 
 */
export function getItemByKey (key, value, tree,childKey='children') {
  //设置结果
  let result;
  if (!tree) {
    return;//如果data传空，直接返回
  }
  for (let i = 0; i < tree.length; i++) {
    let item = tree[i];
    if (item[key] === value) {
      result = item;
      //找到id相等的则返回父id
      return result;
    } else if (item && item[childKey] && item[childKey].length > 0) {
      //如果有子集，则把子集作为参数重新执行本方法
      result= getItemByKey(key, value, item[childKey], childKey);
      //关键，千万不要直接return本方法，不然即使没有返回值也会将返回return，导致最外层循环中断，直接返回undefined,要有返回值才return才对
      if(result){
        return result;
      }
    }
  }
  //如果执行循环中都没有return，则在此return
  return result;
}